import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import {
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";

function PieChartContainer({
  image,
  title,
  partsDescriptor,
  bulletImages,
  Component,
  iconImage,
}) {
  return (
    <VisibilitySensor partialVisibility>
      {({ isVisible }) => (
        <div className="pie-chart-container">
          <div className="pie-chart-container__image-wrapper">
            <img
              src={image}
              className={`pie-chart-container__image${setAdditionalClasses(
                ["icon-image"],
                [iconImage]
              )}`}
              alt=""
              style={getVisibleSensorAnimation(
                isVisible,
                iconImage
                  ? "fadeIn 1s 0.6s backwards"
                  : "pie-chart-rotate 1s 0.45s backwards"
              )}
            />
          </div>
          <span className="pie-chart-container__title">{title}</span>
          <div className="pie-chart-container__part-descriptor">
            {partsDescriptor &&
              partsDescriptor.map((part, index) => (
                <div
                  className="pie-chart-container__part-descriptor-item"
                  key={index}
                >
                  <img
                    src={bulletImages[part.imageIndex]}
                    alt=""
                    className="part-descriptor__bullet-image"
                  />
                  <span className="part-descriptor__label">{part.label}</span>
                  <span style={{ width: "10px" }}></span>
                  <span className="part-descriptor__value">{part.value}</span>
                </div>
              ))}
            {Component}
          </div>
        </div>
      )}
    </VisibilitySensor>
  );
}

export default PieChartContainer;
